import React, { useState, useEffect } from 'react';
import { employeeStrategyMap, groupStrategyMap } from './config.jsx';

const useEdit = (props) => {
  const [strategy, setStrategy] = useState('');
  const [selectedEmployeeDistributor, setSelectedEmployeeDistributor] = React.useState([]);
  const [selectedGroupDistributor, setSelectedGroupDistributor] = React.useState([]);
  const [totalEmployeeList, setTotalEmployeeList] = React.useState([]);
  const [totalGroupList, setTotalGroupList] = React.useState([]);
  const [target, setTarget] = useState('USER');
  const [ruleSource, setRuleSource] = useState(0);
  const [selectedDistributorObj, setSelectedDistributorInternal] = useState({
    selectedDistributor: selectedEmployeeDistributor,
    // setSelectedDistributor: setSelectedEmployeeDistributor,
    setSelectedEmployeeDistributor,
    setSelectedGroupDistributor,
    totalListOfDistributor: totalEmployeeList,
    targetName: '员工',
    targetKey: 'userId',
    targetSearchFields: ['name'],
    strategyMap: employeeStrategyMap,
  });
  useEffect(() => {
    setTotalEmployeeList(props.employeeList);
  }, [props.employeeList]);

  useEffect(() => {
    setTotalGroupList(props.groupList);
  }, [props.groupList]);

  useEffect(() => {
    if (target == 'USER') {
      setSelectedDistributorInternal({
        selectedDistributor: selectedEmployeeDistributor,
        // setSelectedDistributor: setSelectedEmployeeDistributor,
        setSelectedEmployeeDistributor,
        setSelectedGroupDistributor,
        totalListOfDistributor: totalEmployeeList,
        targetName: '员工',
        targetKey: 'userId',
        targetSearchFields: ['name'],
        strategyMap: employeeStrategyMap,
      });
    } else {
      setSelectedDistributorInternal({
        selectedDistributor: selectedGroupDistributor,
        // setSelectedDistributor: setSelectedGroupDistributor,
        setSelectedEmployeeDistributor,
        setSelectedGroupDistributor,
        totalListOfDistributor: totalGroupList,
        targetName: '团队',
        targetKey: 'userGroupId',
        targetSearchFields: ['userGroupName'],
        strategyMap: groupStrategyMap,
      });
    }
  }, [target, selectedEmployeeDistributor, selectedGroupDistributor, totalEmployeeList, totalGroupList]);

  const onStrategyChange = (e, value) => {
    setStrategy(value);
  };

  return {
    strategyHooks: {
      value: strategy,
      onChange: onStrategyChange,
    },
    target,
    setTarget,
    strategy,
    setStrategy,
    ruleSource,
    setRuleSource,
    ...selectedDistributorObj,
  };
};

export default useEdit;
